export const GET_DYNAMIC_PRICING_LIST = "GET_DYNAMIC_PRICING_LIST";
export const SET_DYNAMIC_PRICING_LIST = "SET_DYNAMIC_PRICING_LIST";
export const GET_DYNAMIC_PRICING_BY_ID = "GET_DYNAMIC_PRICING_BY_ID";
export const SET_DYNAMIC_PRICING_DETAILS = "SET_DYNAMIC_PRICING_DETAILS";
export const CREATE_DYNAMIC_PRICING = "CREATE_DYNAMIC_PRICING";
export const UPDATE_DYNAMIC_PRICING = "UPDATE_DYNAMIC_PRICING";
export const DELETE_DYNAMIC_PRICING = "DELETE_DYNAMIC_PRICING";
export const SET_DYNAMIC_PRICING_LOADER = "SET_DYNAMIC_PRICING_LOADER";
export const GET_DYNAMIC_PRICING_FILTERS = "GET_DYNAMIC_PRICING_FILTERS";
export const SET_DYNAMIC_PRICING_FILTERS = "SET_DYNAMIC_PRICING_FILTERS";
export const SEARCH_DYNAMIC_PRICING = "SEARCH_DYNAMIC_PRICING";
export const BULK_UPLOAD_DYNAMIC_PRICING = "BULK_UPLOAD_DYNAMIC_PRICING";
export const SYNC_DP_META = "SYNC_DP_META";
